<template>
  <div>
    <keep-alive>
    <div id="transformPage">
      <div class="dod">

        <header class="dod_header">
          <router-link class="dod_header_logo" v-bind:to="{ name: 'home' }">
            ← tmiame
          </router-link>
          <div class="dod_header_copy">
            Days of Design
          </div>
        </header>

        <div class="dod_title is-relative"></div>
        <div class="dod_title" ref="title">
          <div class="dod_title_unknown">DOD</div>
        </div>

        <!--
        @ Days List
        -->
        <div class="dod_dayList">

          <article class="dod_dayItem" id="d33" data-position-id="33">
            <div class="dod_dayItem_view">
              <div class="dod_dayItem_number">33 - Cursor Icon Animation</div>
              <transition name="fade">
                <Day33 v-if="position[33]" />
              </transition>
            </div>
          </article>

          <article class="dod_dayItem" id="d32" data-position-id="32">
            <div class="dod_dayItem_view">
              <div class="dod_dayItem_number">32 - Spring Animation</div>
              <transition name="fade">
                <Day32 v-if="position[32]" />
              </transition>
            </div>
          </article>

          <article class="dod_dayItem" id="d31" data-position-id="31">
            <div class="dod_dayItem_view">
              <div class="dod_dayItem_number">31 - Parallax Scroll Effect</div>
              <transition name="fade">
                <Day31 v-if="position[31]" />
              </transition>
              <router-link class="dod_dayItem_link" v-bind:to="{ name: 'day31' }" v-touchfeedback>
                Fullview
              </router-link>
            </div>
          </article>

          <article class="dod_dayItem is-noTouch" id="d30" data-position-id="30">
            <div class="dod_dayItem_view">
              <div class="dod_dayItem_number">30 - Canvas Blur Animation</div>
              <transition name="fade">
                <Day30 v-if="position[30]" />
              </transition>
            </div>
          </article>

          <article class="dod_dayItem is-noTouch" id="d29" data-position-id="29">
            <div class="dod_dayItem_view">
              <div class="dod_dayItem_number">29 - Text Effect</div>
              <transition name="fade">
                <Day29 v-if="position[29]" />
              </transition>
            </div>
          </article>

          <article class="dod_dayItem is-noTouch" id="d26" data-position-id="26">
            <div class="dod_dayItem_view">
              <div class="dod_dayItem_number">26 - Canvas Rainbow Animation</div>
              <transition name="fade">
                <Day26 v-if="position[26]" />
              </transition>
            </div>
          </article>

          <article class="dod_dayItem" id="dod25" data-position-id="25">
            <div class="dod_dayItem_view">
              <div class="dod_dayItem_number">25 - Canvas Pixelate Particle</div>
              <transition name="fade">
                <Day25 v-if="position[25]" />
              </transition>
            </div>
          </article>

          <article class="dod_dayItem is-noTouch dod_dayItem--text-white" id="dod24" data-position-id="24">
            <div class="dod_dayItem_view">
              <div class="dod_dayItem_number">24 - Text Effect</div>
              <transition name="fade">
                <Day24 v-if="position[24]" />
              </transition>
            </div>
          </article>

          <article class="dod_dayItem is-noTouch dod_dayItem--text-white" data-position-id="23">
            <div class="dod_dayItem_view">
              <div class="dod_dayItem_number">23 - Text Effect</div>
              <transition name="fade">
                <Day23 v-if="position[23]" />
              </transition>
            </div>
          </article>

          <article id="d22" class="dod_dayItem is-noTouch" data-position-id="22">
            <div class="dod_dayItem_view">
              <h3 class="dod_dayItem_number">22 - Particle</h3>
              <transition name="fade">
                <Day22 v-if="position[22]" />
              </transition>
            </div>
          </article>

          <article id="d21" class="dod_dayItem is-noTouch" data-position-id="21">
            <div class="dod_dayItem_view">
              <h3 class="dod_dayItem_number">21 - Particle</h3>
              <transition name="fade">
                <Day21 v-if="position[21]" />
              </transition>
            </div>
          </article>

          <article id="d20" class="dod_dayItem" data-position-id="20">
            <div class="dod_dayItem_view" id="dod20">
              <div class="dod_dayItem_number">20 - Dominant Color</div>
              <transition name="fade">
                <Day20 v-if="position[20]" />
              </transition>
            </div>
          </article>

          <article id="d19" class="dod_dayItem is-noTouch" data-position-id="19">
            <div class="dod_dayItem_view">
              <h3 class="dod_dayItem_number">19 - Text Animation</h3>
              <transition name="fade">
                <Day19 v-if="position[19]" />
              </transition>
            </div>
          </article>

          <article class="dod_dayItem dod_dayItem--text-white" data-position-id="18">
            <div class="dod_dayItem_view">
              <div class="dod_dayItem_number">18 - Blur Circle Particle</div>
              <transition name="fade">
                <Day18 v-if="position[18]" />
              </transition>
            </div>
          </article>

          <article class="dod_dayItem" data-position-id="17">
            <div class="dod_dayItem_view">
              <div class="dod_dayItem_number">17 - Login Form</div>
              <transition name="fade">
                <Day17 v-if="position[17]" />
              </transition>
            </div>
          </article>

          <article class="dod_dayItem dod_dayItem--text-white" data-position-id="16">
            <div class="dod_dayItem_view">
              <div class="dod_dayItem_number">16 - Pixi.js 2D Particle (ParticleContainer)</div>
              <transition name="fade">
                <Day16 v-if="position[16]" />
              </transition>
            </div>
          </article>

          <article class="dod_dayItem" data-position-id="14">
            <div class="dod_dayItem_view">
              <div class="dod_dayItem_number">14 - Pixi.js 2D Particle (Sprite & Graphics)</div>
              <transition name="fade">
                <Day14 v-if="position[14]" />
              </transition>
            </div>
          </article>

          <article class="dod_dayItem" data-position-id="15">
            <div class="dod_dayItem_view">
              <div class="dod_dayItem_number">15 - iOS Like Scroll Top Effect (Only Safari)</div>
              <transition name="fade">
                <Day15 v-if="position[15]" />
              </transition>
              <router-link class="dod_dayItem_link" v-bind:to="{ name: 'day15' }" v-touchfeedback>
                Open DEMO
              </router-link>
              <aside class="dod_dayItem_attention">
                <div class="dod_dayItem_attention_box">
                  <p>Only Safari</p>
                </div>
              </aside>
            </div>
          </article>

          <article class="dod_dayItem" data-position-id="13">
            <div class="dod_dayItem_view">
              <div class="dod_dayItem_number">13 - Modal 2019</div>
              <transition name="fade">
                <Day13 v-if="position[13]" />
              </transition>
              <a class="dod_dayItem_link" v-on:click="onOpenModal(13)" v-touchfeedback>
                Open Modal
              </a>
            </div>
          </article>

          <article class="dod_dayItem" data-position-id="12">
            <div class="dod_dayItem_view">
              <div class="dod_dayItem_number">12 - Scroll Parallax Animation</div>
              <transition name="fade">
                <Day12 v-if="position[12]" />
              </transition>
              <router-link class="dod_dayItem_link" v-bind:to="{ name: 'day12' }" v-touchfeedback>
                Fullview
              </router-link>
            </div>
          </article>

          <article class="dod_dayItem" data-position-id="11">
            <div class="dod_dayItem_view">
              <div class="dod_dayItem_number">11 - Triangle _ canvas</div>
              <transition name="fade">
                <Day11 v-if="position[11]" />
              </transition>
            </div>
          </article>
          <article class="dod_dayItem" data-position-id="10">
            <div class="dod_dayItem_view">
              <div class="dod_dayItem_number">10 - Triangle _ canvas</div>
              <transition name="fade">
                <Day10 v-if="position[10]" />
              </transition>
            </div>
          </article>

          <article id="d9" class="dod_dayItem" data-position-id="9">
            <div class="dod_dayItem_view">
              <div class="dod_dayItem_number">9 - Triangle _ canvas</div>
              <transition name="fade">
                <Day09 v-if="position[9]" />
              </transition>
            </div>
          </article>

          <article id="d8" class="dod_dayItem" data-position-id="8">
            <div class="dod_dayItem_view">
              <div class="dod_dayItem_number">8 - Triangle _ canvas</div>
              <transition name="fade">
                <Day08 v-if="position[8]" />
              </transition>
            </div>
          </article>

          <article id="d7" class="dod_dayItem" data-position-id="7">
            <div class="dod_dayItem_view">
              <h3 class="dod_dayItem_number">7 - hamburger menu</h3>
              <transition name="fade">
                <Day07 v-if="position[7]" />
              </transition>
            </div>
          </article>

          <article id="d6" class="dod_dayItem is-noTouch" data-position-id="6">
            <div class="dod_dayItem_view">
              <h3 class="dod_dayItem_number">6 - Triangle</h3>
              <transition name="fade">
                <Day06 v-if="position[6]" />
              </transition>
            </div>
          </article>

          <article id="d5" class="dod_dayItem is-noTouch" data-position-id="5">
            <div class="dod_dayItem_view">
              <h3 class="dod_dayItem_number">5 - Dot Spinner</h3>
              <transition name="fade">
                <Day05 v-if="position[5]" />
              </transition>
            </div>
          </article>

          <article id="d4" class="dod_dayItem is-noTouch" data-position-id="4">
            <div class="dod_dayItem_view">
              <h3 class="dod_dayItem_number">4 - Spinner Dot</h3>
              <transition name="fade">
                <Day04 v-if="position[4]" />
              </transition>
            </div>
          </article>

          <article id="d3" class="dod_dayItem is-noTouch" data-position-id="3">
            <div class="dod_dayItem_view">
              <h3 class="dod_dayItem_number">3 - Spinner Canvas</h3>
              <transition name="fade">
                <Day03 v-if="position[3]" />
              </transition>
            </div>
          </article>

          <article id="d2" class="dod_dayItem is-noTouch" data-position-id="2">
            <div class="dod_dayItem_view">
              <h3 class="dod_dayItem_number">2 - Spinner SVG & CSS</h3>
              <transition name="fade">
                <Day02 v-if="position[2]" />
              </transition>
            </div>
          </article>

          <article id="d1" class="dod_dayItem is-noTouch" data-position-id="1">
            <div class="dod_dayItem_view">
              <h3 class="dod_dayItem_number">1 - Spinner CSS Only</h3>
              <transition name="fade">
                <Day01 v-if="position[1]" />
              </transition>
            </div>
          </article>

          <article id="d0" class="dod_dayItem" data-position-id="0">
            <div class="dod_dayItem_view">
              <h3 class="dod_dayItem_number">0 - Back to top</h3>
              <transition name="fade">
                <Day00
                  v-if="position[0]"
                  v-on:backtotop="onBackToTop"
                />
              </transition>
            </div>
          </article>

        </div>
      </div><!-- /dod -->
    </div><!-- /#transformPage -->
    </keep-alive>

    <Day13Modal
      v-if="modal[13]"
      v-on:close="onCloseModal"
      v-on:preclose="onPreCloseModal"
    />

  </div>
</template>

<script>
import anime from 'animejs'
import SelfPosition from '@/helpers/self-position'

import Day13Modal from '@/components/daysofdesign/Day13Modal'

export default {
  name: 'dod',
  data: () => ({
    selfPosition: false,
    pageTransformBeforePosition: 0,
    position: {
      0: false,
      1: false,
      2: false,
      3: false,
      4: false,
      5: false,
      6: false,
      7: false,
      8: false,
      9: false,
      10: false,
      11: false,
      12: false,
      13: false,
      14: false,
      15: false,
      16: false,
      17: false,
      18: false,
      19: false,
      20: false,
      21: false,
      22: false,
      23: false,
      24: false,
      25: false,
      26: false,
      27: false,
      29: false,
      30: false,
      31: false,
      32: false,
      33: false
    },
    modal: {
      13: false
    }
  }),
  components: {
    Day13Modal,
    Day00: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day00'),
    Day01: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day01'),
    Day02: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day02'),
    Day03: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day03'),
    Day04: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day04'),
    Day05: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day05'),
    Day06: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day06'),
    Day07: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day07'),
    Day08: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day08'),
    Day09: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day09'),
    Day10: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day10'),
    Day11: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day11'),
    Day12: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day12'),
    Day13: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day13'),
    Day14: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day14'),
    Day15: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day15'),
    Day16: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day16'),
    Day17: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day17'),
    Day18: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day18'),
    Day19: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day19'),
    Day20: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day20'),
    Day21: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day21'),
    Day22: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day22'),
    Day23: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day23'),
    Day24: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day24'),
    Day25: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day25'),
    Day26: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day26'),
    Day29: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day29'),
    Day30: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day30'),
    Day31: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day31'),
    Day32: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day32'),
    Day33: () => import(/* webpackPrefetch: true */'@/components/daysofdesign/Day33')
  },
  methods: {
    /**
     * モーダルを表示
     *
     * @param {Number} dayNumber
     */
    onOpenModal(dayNumber = false) {
      if (!dayNumber) {
        return
      }
      if (this.modal[dayNumber] === undefined) {
        return
      }
      this.modal[dayNumber] = true

      this.emithandlerDisableSelfPosition()
      this.scrollTransformPage()
    },

    /**
     * モーダルを閉じる
     *
     * @param {Number} dayNumber
     */
    onCloseModal() {
      for (let key of Object.keys(this.modal)) {
        this.modal[key] = false
      }

      this.emithandlerEnableSelfPosition()
    },

    /**
     * モーダルを閉じる
     */
    onPreCloseModal() {
      this.resetTransformPage()
    },

    /**
     * 要素が画面内に表示されているかの監視を停止
     */
    emithandlerDisableSelfPosition() {
      if (this.selfPosition) {
        this.stopSelfPosition()

        // 全てのコンポーネントを非表示
        for (let key of Object.keys(this.position)) {
          this.position[key] = false
        }
      }
    },

    /**
     * 要素が画面内に表示されているかの監視を再開
     */
    emithandlerEnableSelfPosition() {
      if (this.selfPosition) {
        this.restartSelfPosition()
      }
    },

    // メインビュー固定表示
    scrollTransformPage() {
      this.pageTransformBeforePosition = [
        window.scrollLeft || window.scrollX,
        window.scrollTop || window.scrollY
      ]
      document.getElementById('transformPage').style.transform = `translateY(-${this.pageTransformBeforePosition[1]}px)`
      document.getElementById('transformPage').className = 'is-fixed'
      window.scrollTo(0, 0)
      document.body.classList.add('is-openModal')
    },

    // メインビュー固定表示を破棄
    resetTransformPage() {
      document.body.classList.remove('is-openModal')
      document.getElementById('transformPage').style.transform = null
      document.getElementById('transformPage').className = null
      window.scrollTo(...this.pageTransformBeforePosition)
    },

    onBackToTop() {
      this.emithandlerDisableSelfPosition()

      anime({
        targets: 'html, body',
        scrollTop: 0,
        duration: 1500,
        easing: 'easeInOutQuad',
        complete: () => {
          this.emithandlerEnableSelfPosition()
        }
      })

      anime({
        targets: this.$refs.title,
        translateZ: 0,
        scaleY: [
          { value: 2, duration: 2000 },
          { value: 1, easing: 'easeOutElastic(1, 0.8)', duration: 1000 }
        ],
        duration: 1500,
        easing: 'easeInOutQuad',
        begin: () => {
          if (this.$refs.title) {
            this.$refs.title.classList.add('is-backtotop')
          }
          document.addEventListener('wheel', this.handleWheel, false)
          document.addEventListener('touchmove', this.handleWheel, false)
        },
        complete: () => {
          if (this.$refs.title) {
            this.$refs.title.classList.remove('is-backtotop')
          }
          document.removeEventListener('wheel', this.handleWheel, false)
          document.removeEventListener('touchmove', this.handleWheel, false)
        }
      })
    },

    handleWheel(e) {
      e.preventDefault()
    },

    stopSelfPosition() {
      this.selfPosition.destroyIntersectionObserver()
    },

    restartSelfPosition() {
      this.selfPosition.initIntersectionObserver()
    }
  },

  mounted() {
    this.selfPosition = new SelfPosition([...document.querySelectorAll('.dod_dayItem')], {
      repeat: true,
      targetDataId: 'position-id'
    })
    this.selfPosition.on('in', (el, dataId) => {
      this.$nextTick(() => {
        this.position[dataId] = true
      })
    })
    this.selfPosition.on('out', (el, dataId) => {
      this.$nextTick(() => {
        this.position[dataId] = false
      })
    })
  },

  created() {
  },

  beforeDestroy() {
    if (this.selfPosition) {
      this.selfPosition.destroy()
    }
  }
}
</script>
